export default "__VITE_ASSET__Ba0gh0ci__"